<template>
	<v-card>
		<v-card-title
			class="d-flex align-center mb-4"
		>
			<v-icon
				icon="$mobile"
				start
			/>
			<translate>Phone Data</translate>
		</v-card-title>
		<v-card-text>
			<v-form
				ref="form"
			>
				<v-row>
					<v-col>
						<v-text-field
							v-model="editedOrderRow.ean"
							:rules="[v => !!v || errors || $gettext('EAN is required')]"
							:error-messages="$gettext(eanError)"
							:label="$gettext('EAN')"
							placeholder="0842776111623"
							persistent-placeholder
							required
							variant="outlined"
						/>
					</v-col>
					<v-col>
						<v-select
							v-model="editedOrderRow.device"
							:label="$gettext('Device Name')"
							required
							:items="devices"
							item-title="full_name"
							item-value="id"
							:disabled="disableDevices"
							variant="outlined"
						/>
					</v-col>
					<v-col
						cols="auto"
						class="d-flex align-center mb-6"
					>
						<v-btn
							color="primary"
							variant="flat"
							@click="findDevices"
						>
							<translate>Find Devices</translate>
						</v-btn>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-select
							v-model="domain"
							:items="domains"
							:rules="[v => !!v || $gettext('Domain is required')]"
							:label="$gettext('Domain')"
							item-title="name"
							item-value="id"
							return-object
							required
							variant="outlined"
						/>
					</v-col>
					<v-col>
						<date-picker
							v-model="editedOrderRow.insuranceStartDate"
							:label="$gettext('Insurance Start Date')"
							:rules="[v => !!v || $gettext('Insurance start date is required')]"
							name="insurance_start_date"
							required
						/>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
		<v-card-actions>
			<v-switch
				v-model="editedOrderRow.refurbishedDevice"
				color="primary"
				:label="$gettext('This device is an outlet model or a refurbished phone')"
				hide-details
			/>
			<v-btn
				color="primary"
				:disabled="!isComplete"
				@click="$emit('update:next',domain)"
			>
				<translate>Next</translate>
			</v-btn>
		</v-card-actions>
	</v-card>
</template>
<script>

import axios from 'axios';
import {
	displayError,
} from 'laravel-front-library';

export default {
	name: 'OrderDevicePicker',
	props: {
		orderRow: {
			type: Object,
			required: true,
		},
	},

	emits: ['update:orderRow', 'update:next', 'update:domain',],

	data () {
		return {
			devices: [],
			disableDevices: true,
			errors: false,
			eanError: '',
			editedOrderRow: {
				...this.orderRow
			},
			domains: [],
			domain: null,
		};
	},

	computed: {
		isComplete () {
			return this.editedOrderRow && this.editedOrderRow.device && this.editedOrderRow.insuranceStartDate && this.domain;
		}
	},

	watch: {
		editedOrderRow: {
			/**
			 * Emit the personal information data when a change is detected
			 */
			handler () {
				this.$emit('update:orderRow', this.editedOrderRow);
			},
			deep: true
		},
		orderRow: {

			/**
			 * Emit the personal information data when a change is detected
			 */
			handler () {
				this.editedOrderRow = this.orderRow;
			},
			deep: true
		},

		domain: {
			/**
			 * Emit domain when a change is detected
			 */
			handler () {
				this.$emit('update:domain', this.domain);
			},
		}
	},

	/**
	 * Get all the necessary data from the api.
	 *
	 * @returns {void}
	 */
	created () {
		this.getDomains();
	},

	methods: {

		/**
		 * Find all available devices for the specific EAN
		 *
		 * @returns {void}
		 */
		async findDevices () {
			if (this.editedOrderRow.ean) {
				// await this.getInsurances();
				axios.get(`/api/v0/resellers/orders/add/devices?ean=${this.editedOrderRow.ean}`)
					.then(({
						data
					}) => {
						if(data.success) {
							this.devices = data.devices;
							this.editedOrderRow.device = this.devices[0].id;
							// this.getUpdatedPrice();
							this.disableDevices = false;
							this.eanError = '';
						} else {
							this.eanError = data.messages.ean;
						}
					})
					.catch((error) => {
						if (error.response) {
							this.eanError = error.response.data.messages.ean;
						}
						this.disableDevices = true;
					});
			}
		},


		/**
		 * Get domains
		 *
		 * @returns {void}
		 */
		getDomains () {
			axios.get('add/domains')
				.then(({
					data
				}) => {
					this.domains = data;
				})
				.catch(() => {
					displayError(this.$gettext('Something has gone wrong during get domains request'));
				});
		},
	}
};
</script>

<style scoped>

</style>
